import clinicReducer from './clinicSlice'
import commonReducer from './commonSlice'
import generalDataReducer from './generalDataSlice'
import notificationReducer from './notificationSlice'
import receiveReducer from './receiveSlice'
import searchQueryReducer from './searchQuerySlice'
import serviceReducer from './serviceSlice'
import { configureStore } from '@reduxjs/toolkit'

export const store = configureStore({
  reducer: {
    commonReducer,
    clinicReducer,
    searchQueryReducer,
    notificationReducer,
    receiveReducer,
    generalDataReducer,
    serviceReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export type RootState = ReturnType<typeof store.getState>
